import { Outlet } from "react-router-dom";
import { Banner } from "./components/Banner/Banner";

export const Layout = () => {
  return (
    <div>
      <Banner />
      <div>
        <Outlet />
      </div>
    </div>
  );
};
